import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Settings, Calendar } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function HomeTopBar({ userName, daysUntil }) {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div
      className="relative overflow-hidden text-white px-5 pt-3 pb-4"
      style={{ background: theme.headerGradient }}
      data-testid="home-top-bar"
    >
      {/* Grain overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\' opacity=\'0.5\'/%3E%3C/svg%3E")', backgroundSize: "128px" }} />
      {/* Accent blob */}
      <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-20" style={{ background: `radial-gradient(circle, ${theme.headerAccentBlob}, transparent)` }} />

      <div className="relative z-10 flex items-center justify-between">
        <div>
          <p className="text-white/40 text-[10px] font-semibold tracking-widest uppercase">Welcome back</p>
          <h1 className="text-xl font-black tracking-tight" data-testid="home-username">{userName || "Friend"}</h1>
        </div>

        <div className="flex items-center gap-2">
          {/* Countdown badge */}
          {daysUntil != null && daysUntil > 0 && (
            <motion.button
              whileTap={{ scale: 0.9 }}
              onClick={() => navigate("/countdown")}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/10 backdrop-blur-sm bg-white/[0.05]"
              data-testid="home-countdown-badge"
            >
              <Calendar className="w-3 h-3 text-white/50" />
              <span className="text-sm font-black">{daysUntil}</span>
              <span className="text-[9px] text-white/40 font-medium">days</span>
            </motion.button>
          )}

          {/* Profile */}
          <button
            onClick={() => navigate("/profile")}
            className="w-8 h-8 rounded-full bg-white/[0.07] border border-white/[0.08] flex items-center justify-center"
            data-testid="home-profile-btn"
          >
            <Settings className="w-3.5 h-3.5 text-white/40" />
          </button>
        </div>
      </div>
    </div>
  );
}
